import { useNavigate } from 'react-router';

import { useAPICreateChart } from '../../../api/dashboard/useAPICreateChart';
import { useSettingsContext } from '../components/Contexts/SettingsContext/SettingsContext';
import { getDashboardParamForExploreRoute } from '../helpers';
import { getChartData } from './reducers/helpers';

export const useSaveChartToDashboard = () => {
    const navigate = useNavigate();
    const settings = useSettingsContext();

    const { saveChartFromData } = useAPICreateChart(
        (widget, redirect, dashboardSlug) => {
            const shouldRedirect =
                redirect && dashboardSlug && widget.chart?.key !== undefined;
            navigate(
                `/explore/${widget.chart?.key}${getDashboardParamForExploreRoute(dashboardSlug)}`,
                {
                    state: shouldRedirect
                        ? {
                              redirectTo: `/dashboard/${dashboardSlug}#grid-chart-${widget.chart?.key}`,
                          }
                        : {},
                },
            );
        },
    );

    const saveChartToDashboard = (payload: {
        dashboard: { key: number; slug: string };
        explore: ExploreQueryT;
        redirect: boolean;
        snackAction: boolean;
        fromPosition?: FromPositionQueryT;
    }) => {
        const { dashboard, explore, redirect, snackAction, fromPosition } =
            payload;
        const chartData = getChartData(explore, settings);
        saveChartFromData({
            dashboard,
            chartData,
            redirect,
            snackAction,
            fromPosition,
        });
    };

    return { saveChartToDashboard };
};
